import { connectedStore } from '../../store';
import actions from '../actions';

const updateExtension = (slug, updates) => {
  const store = connectedStore.get();
  store.dispatch(actions.updateExtension(slug, updates));
};

export default updateExtension;
